<template>
	<div class="about">
		<div class="header">
			<div class="container">
				<div class="flex">
					<a class="logo"><img src="../../image/zsdb_logo.png" class="logoImg" style="width:132px"></a>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a @click="gotoHome()" class="">首页</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a @click="gotoSociety()" class="">社会招聘</a></li>
							<li class="menulist"><a @click="gotoIntern()" class="">实习生招聘</a></li>
							<li class="menulist"><a @click="gotoAboutus()" class="on">关于我们</a></li>
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../../image/ewm.jpg" class="code">
						<img src="../../image/icoewm.png" slot="reference" class="ico">
					</el-popover>
				</div>
			</div>
		</div>
		<div class="pagesbanner"
			style="background: url(//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_bannergy.jpg) top center no-repeat;">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh01.png"
				class="dh wow  fadeInLeft" style="left: 0">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh02.png"
				class="dh wow  fadeInLeft" style="right: 0">
			<div class="text">
				<h3>关于我们</h3>
				<p>ABOUT US</p>
			</div>
		</div>
		<div class="pagesabout">
			<div class="container">
				<div class="flex">
					<div class="aboutleft">
						<div class="item on">
							<a @click="gotoAboutus()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1on.png"
										class="icoon"></span>
								公司介绍
							</a>
						</div>
						<div class="item ">
							<a @click="gotoProject()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2on.png"
										class="icoon"></span>
								典型工程
							</a>
						</div>
						<div class="item ">
							<a @click="gotoCulture()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3on.png"
										class="icoon"></span>
								人才培养
							</a>
						</div>
						<div class="item ">
							<a @click="gotoLife()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4on.png"
										class="icoon"></span>
								园区生活
							</a>
						</div>
						<div class="item ">
							<a @click="gotoRecruit()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5on.png"
										class="icoon"></span>
								招聘Q&A
							</a>
						</div>

					</div>
					<div class="aboutright">
						<div class="imgbox">
							<div class="imgplay m-video"
								data-src="https://video.dingxikeji.com/mp4/huadongyuan_qiyejieshao.mp4">
								<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aboutimg.png"
									class="img">
								<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_play.png"
									class="ico">
							</div>
							<div class="imgtitle">
								<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dd.png"
									class="ico">公司介绍
							</div>
						</div>
						<div class="aboutcon">
							<div class="text">
								<p>中国电建集团华东勘测设计研究院有限公司（以下简称“华东院”）1954年建院，隶属于中国电力建设集团。中国电力建设集团位居世界500强第107位、ENR全球工程设计企业第1位。
									华东院总部设在杭州，在国内设有东南、华南、西南、华东、华北、东北、浙江等区域总部，在亚太、欧亚、东南非、中西非、美洲、中东北非设有六大区域总部，覆盖50多个国家和地区。业务范围包括水电与新能源、城乡建设、生态与环境等领域，努力打造具有工程全过程智慧化服务能力的一流国际工程公司。
								</p>
								<p>作为国家大型综合性甲级勘测设计研究单位，多年来一直名列中国工程设计企业20强、中国承包商80强、中国勘察设计综合实力百强单位、中国监理行业十大品牌企业。华东院是国家高新技术企业、国家级工业化与信息化“两化”深度融合示范单位、中国对外承包工程业务新签合同额百强企业、住建部首批全过程工程咨询试点企业、全国实施卓越绩效模式先进企业、电力行业首批卓越绩效标杆AAAAA企业、浙江省工程总承包试点企业、浙江省“一带一路”建设示范企业和浙江省规模最大的勘测设计研究单位。2017年荣获第五届全国文明单位称号，2019年荣获全国五一劳动奖状。
								</p>
								<p>华东院持有工程设计综合甲级资质、工程勘察综合甲级资质、工程咨询甲级综合资信和城乡规划编制单位甲级等工程建设领域国家最高等级的资质资信，具有建筑工程施工总承包一级资质，市政施工总承包一级资质，以及规划、建筑、市政公用、电力、水利水电、轨道交通、环境与生态、景观、水土保持、环境影响评价、压力管道设计（GA1、GA2）、水利建设工程监理、工程总承包、水文水资源调查评价、水资源论证、工程造价咨询、中国对外承包工程经营资格证书等10余项资质证书。设有3个国家级研发中心以及10多个省部级以上的专业技术研发中心。
									华东院现有员工约5000人，持有国家各类注册执业资格证书2200余人次。取得1000余项国家和省部级科技成果奖，3300余项授权专利，和870余项软件著作权。设有博士后科研工作站，博士后140余人；全国工程勘察设计大师2人，省级工程勘察设计大师17人；享受国务院特殊津贴专家、国家百千万人才、国家突出贡献中青年专家等20余人；发改委、商务部、水利部、浙江省等省部级及以上各类专家人才1000余人次。
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>


		</div>
		<backtop></backtop>
	</div>
</template>
<script>
	import backtop from "../../components/backtop.vue"
	import {
		loginstatus,
		Logout,
	} from '../../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			backtop,
		},
		data() {
			return {
				value1: '',
				islogin: false,
				unlogin: false,
			}
		},

		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			})
		},

		methods: {
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotoHome() {
				this.$router.push('/')
			},
			// gotoAboutus() {
			// 	this.$router.push('/aboutus/introduce')
			// },
			gotoCampus() {
				this.$router.push('/campus')
			},
			gotoSociety() {
				this.$router.push('/society')
			},
			gotoIntern() {
				this.$router.push('/intern')
			},
			gotoProject() {
				this.$router.push('/aboutus/project')
			},
			gotoCulture() {
				this.$router.push('/aboutus/culture')
			},
			gotoLife() {
				this.$router.push('/aboutus/life')
			},
			gotoRecruit() {
				this.$router.push('/aboutus/recruit')
			},
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}
</script>

<style scoped>
	@import url(../../assets/css/index.css);
</style>
